import { MODEL_KEYS } from '../../../model'

export const USER_CLASS_NAME = 'User'

export const USER_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  EMAIL: 'email',
  PASSWORD: 'password',
  APPLE_ID: 'appleId',
  FACEBOOK_ID: 'facebookId', // @deprecated
  FACEBOOK_TOKEN: 'facebookToken', // @deprecated
  GOOGLE_ID: 'googleId',
  VERIFIED_AT: 'verifiedAt',
  NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',

  NEW_CUSTOMER_DISCOUNT_EXPIRES_AT: 'newCustomerDiscountExpiresAt',

  PAYING_SUBSCRIPTION: 'payingSubscription',

  SUBSCRIPTION_FREE_TRIAL_STARTED_AT: 'subscriptionFreeTrialStartedAt',
  SUBSCRIPTION_FREE_TRIAL_EXTENDED_AT: 'subscriptionFreeTrialExtendedAt',
  SUBSCRIPTION_FREE_TRIAL_EXTENDED_REASON: 'subscriptionFreeTrialExtendedReason',
  SUBSCRIPTION_FREE_TRIAL_ENDED_AT: 'subscriptionFreeTrialEndedAt',
  SUBSCRIPTION_CANCELED_AT: 'subscriptionCanceledAt',
  SUBSCRIPTION_STARTED_AT: 'subscriptionStartedAt',
  SUBSCRIPTION_DISCOUNT_APPLIED_AT: 'subscriptionDiscountAppliedAt',
  SUBSCRIPTION_DISCOUNT_REASON: 'subscriptionDiscountReason',
  SUBSCRIPTION_PLAN: 'subscriptionPlan',
  SUBSCRIPTION_PLANS: 'subscriptionPlans',
  STRIPE_CUSTOMER_ID: 'stripeCustomerId',
  STRIPE_SUBSCRIPTION_ID: 'stripeSubscriptionId',
  STRIPE_SUBSCRIPTION_IDS: 'stripeSubscriptionIds',

  // Associations
  SETTINGS: 'settings',
  PROFILES: 'profiles'
}

export const USER_JWT_KEYS = [
  USER_KEY.ID,
  USER_KEY.EMAIL
]

export const USER_PRIVATE_KEYS = [
  USER_KEY.PASSWORD
]

export const USER_ASSOCIATIONS = [
  USER_KEY.SETTINGS,
  USER_KEY.PROFILES
]

export const USER_KEYS_FOR_CREATOR = [
  ...MODEL_KEYS,
  USER_KEY.EMAIL,
  USER_KEY.FIRST_NAME,
  USER_KEY.LAST_NAME,
  USER_KEY.APPLE_ID,
  USER_KEY.GOOGLE_ID,
  USER_KEY.PAYING_SUBSCRIPTION,
  USER_KEY.STRIPE_SUBSCRIPTION_ID,
  USER_KEY.STRIPE_SUBSCRIPTION_IDS,
  USER_KEY.STRIPE_CUSTOMER_ID,
  USER_KEY.SUBSCRIPTION_PLANS,
  USER_KEY.SUBSCRIPTION_PLAN,
  USER_KEY.SUBSCRIPTION_STARTED_AT,
  USER_KEY.SUBSCRIPTION_FREE_TRIAL_STARTED_AT,
  USER_KEY.SUBSCRIPTION_FREE_TRIAL_ENDED_AT
]

export const USER_KEYS_TO_OMIT_WHEN_UPDATING = [
  USER_KEY.ID,
  USER_KEY.CLASS_NAME,
  USER_KEY.APPLE_ID,
  USER_KEY.FACEBOOK_ID,
  USER_KEY.FACEBOOK_TOKEN,
  USER_KEY.GOOGLE_ID,
  USER_KEY.VERIFIED_AT,
  USER_KEY.PAYING_SUBSCRIPTION,
  USER_KEY.SUBSCRIPTION_FREE_TRIAL_STARTED_AT,
  USER_KEY.SUBSCRIPTION_FREE_TRIAL_ENDED_AT,
  USER_KEY.SUBSCRIPTION_CANCELED_AT,
  USER_KEY.SUBSCRIPTION_STARTED_AT,
  USER_KEY.SUBSCRIPTION_PLAN,
  USER_KEY.SUBSCRIPTION_PLANS,
  USER_KEY.STRIPE_CUSTOMER_ID,
  USER_KEY.STRIPE_SUBSCRIPTION_ID,
  USER_KEY.STRIPE_SUBSCRIPTION_IDS
]

export const USER_AUDIT = {
  DELETED: 'User Deleted',
  VERIFIED: 'User Verified',
  PASSWORD_CHANGED: 'User Password Changed',
  SUBSCRIPTION_CANCELED: 'User Subscription Canceled',
  SUBSCRIPTION_CANCELED_FROM_ADMIN: 'User Subscription Canceled From Admin'
}

export const USER_SCOPE = {

  /**
   * Only returns the public attributes of a `User`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: USER_PRIVATE_KEYS
    }
  }

}
